module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_plus-994d5251a666dce7079fab11a6179020.svg";